<div class="material-lines-panel" *ngIf="materials.length > 0">
  <h3>{{ 'CCR.DETAILS.' + titlePart | translate }}</h3>

  <div class="row cell headings hide-xs">
    <div class="col-md">
      {{ 'ORDERS.MATERIAL.LABELS.PACKING' | translate }}
    </div>
    <div class="col-md">
      {{ 'ORDERS.MATERIAL.LABELS.STATUS' | translate }}
    </div>
    <div class="col-md">
      {{ 'ORDERS.MATERIAL.LABELS.LOGISTIC_VAR' | translate }}
    </div>
    <div class="col-md">
      {{ 'ORDERS.MATERIAL.LABELS.QTY' | translate }}
    </div>
    <div class="col-md"></div>
  </div>

  <div class="hr-accent no_margin_bottom hide-xs"></div>

  <div *ngFor="let material of materials; index as i" class="striped" [ngClass]="{ readonly: readonly }">
    <div class="material_line" *ngIf="material.type === 'packing' || material.type === 'combination'">
      <div class="col-md packingType">
        <div class="connector" *ngIf="material.type === 'combination'">
          <app-connector [height]="connectorHeight" [width]="connectorWidth"></app-connector>
        </div>
        <eps-select
          [options]="definitions.packing.type"
          [value]="material.packingId"
          readonly
          label="ORDERS.MATERIAL.LABELS.PACKING"
          [labelPosition]="labelPosition"
          ></eps-select>
      </div>
      <div class="col-md">
        <eps-select
          [options]="definitions.packing.status"
          [value]="material.packingStatus"
          readonly
          label="ORDERS.MATERIAL.LABELS.STATUS"
          [labelPosition]="labelPosition"
        ></eps-select>
      </div>
      <div class="col-md">
        <eps-select
          [options]="definitions.order.logisticsVarietyPacking"
          [value]="material.logisticsVarietyPacking"
          readonly
          label="ORDERS.MATERIAL.LABELS.LOGISTIC_VAR"
          [labelPosition]="labelPosition"
        ></eps-select>
      </div>
      <div class="col-md">
        <eps-label-body
          label="ORDERS.MATERIAL.LABELS.QTY"
          [labelPosition]="labelPosition"
        >
          {{ material.packingQuantity }}
        </eps-label-body>
      </div>
      <div class="col-md icon-buttons">
        <div *ngIf="!readonly">
          <i class="fa fa-2x fa-pencil edit" aria-hidden="true" (click)="editMaterialClicked.emit(material)"></i>
          <i class="fa fa-2x fa-trash-o remove" aria-hidden="true" (click)="removeMaterialClicked.emit(material)"></i>
        </div>
      </div>
    </div>
    <div class="material_line" [ngClass]="{ combination: material.type === 'combination' }" *ngIf="material.type === 'pallet' || material.type === 'combination'">
      <div class="col-md">
        <eps-select
          [options]="definitions.pallet.type"
          [value]="material.palletId"
          readonly
          label="ORDERS.MATERIAL.LABELS.TYPES.PALLET"
          [labelPosition]="labelPosition"
        ></eps-select>
      </div>
      <div class="col-md">
        <eps-select
          [options]="definitions.packing.status"
          [value]="material.packingStatus"
          readonly
          label="ORDERS.MATERIAL.LABELS.STATUS"
          [labelPosition]="labelPosition"
          *ngIf="material.type === 'pallet'"
        ></eps-select>
      </div>
      <div class="col-md">
        <eps-select
          [options]="definitions.order.logisticsVarietyPacking"
          [value]="material.logisticsVarietyPacking"
          readonly
          label="ORDERS.MATERIAL.LABELS.LOGISTIC_VAR"
          [labelPosition]="labelPosition"
        ></eps-select>
      </div>
      <div class="col-md">
        <eps-label-body
          label="ORDERS.MATERIAL.LABELS.QTY"
          [labelPosition]="labelPosition"
        >
          {{ material.numberOfPallets }}
        </eps-label-body>
      </div>
      <div class="col-md icon-buttons">
        <div *ngIf="material.type !== 'combination' && !readonly">
          <i class="fa fa-2x fa-pencil edit" aria-hidden="true" (click)="editMaterialClicked.emit(material)"></i>
          <i class="fa fa-2x fa-trash-o remove" aria-hidden="true" (click)="removeMaterialClicked.emit(material)"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="hr-accent"></div>
</div>
